import React, { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faTimes,
  faPlus,
  faSeedling,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../../context/AuthContext";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import "./AddGranjaForm.css"; // Importa el archivo CSS

const AddGranjaForm = () => {
  const { setShowAddGranja, fetchMisGranjas, setLoading } =
    useShoppingContext();
  const { authenticatedUser } = useAuth();

  const [formData, setFormData] = useState({
    nombre: "",
    ubicacion: "",
    userId: authenticatedUser.id, // Asigna automáticamente el userId del usuario autenticado
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowAddGranja(false);
    setLoading("Creando granja");
    axios
      .post(`${process.env.REACT_APP_API_URL}/granjas`, formData)
      .then(() => {
        fetchMisGranjas();
        setLoading(false);
      })
      .catch((error) => console.error("Error al agregar la granja:", error));
  };

  return (
    <div className="add-form-container">
      <form onSubmit={handleSubmit} className="add-granja-form">
        <h2 className="add-granja-form-title">
          <FontAwesomeIcon icon={faSeedling} /> Nueva Granja
        </h2>
        <div className="add-granja-form-group">
          <label htmlFor="nombre" className="add-granja-form-label">
            Nombre de la Granja
          </label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className="add-granja-form-input"
            required
          />
        </div>
        <div className="add-granja-form-group">
          <label htmlFor="ubicacion" className="add-granja-form-label">
            <FontAwesomeIcon icon={faMapMarkerAlt} /> Ubicación
          </label>
          <input
            type="text"
            id="ubicacion"
            name="ubicacion"
            value={formData.ubicacion}
            onChange={handleChange}
            className="add-granja-form-input"
            required
          />
        </div>
        <div className="add-ave-form-buttons">
          <button
            type="button"
            onClick={() => setShowAddGranja(false)}
            className=" btn btn-green-outline"
          >
            <FontAwesomeIcon icon={faTimes} /> Cancelar
          </button>
          <button type="submit" className="btn btn-green">
            <FontAwesomeIcon icon={faPlus} /> Agregar
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddGranjaForm;
